import * as R from 'ramda';

export const formatAs800PhoneNumber = (phone?: string | null): string => {
  if (R.isNil(phone)) {
    return '';
  }

  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11 && cleaned.startsWith('8')) {
    return `8(${cleaned.substring(1, 4)})${cleaned.substring(4, 7)}-${cleaned.substring(7, 9)}-${cleaned.substring(9)}`;
  }

  return phone;
}